<template>
    <div>

<section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-3 searching">
                        <span class="h_page">Proses SK Tunggal (Pembatalan)</span> <br> <br>
                    </div>
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                            </span>
                            <input type="text" class="form-control" placeholder="Cari data" id="caridata" >
                        </div> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                <br>
                <div class="table-responsive">
                    <table class="table table-bordered" style="width: 100%">
                        <thead>
                        <tr class="bg-info">
                            <th style="width: 5%">No.</th>
                            <th style="width: 30%">Wilayah</th>
                            <th style="width: 30%">Kabupaten</th>
                            <th style="width: 20%">Kecamatan</th>
                            <th style="width: 15%">#</th>
                        </tr>
                        </thead>
                        <tbody>
                          <tr class="h_isitable" >
                              <td>1.</td>
                              <td>Sulawesi Tenggara</td>
                              <td>Konawe Selatan</td>
                              <td>Palangga</td>
                              <td class="text-center" >

                                <button class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                    <i class="material-icons" >create</i>
                                </button>

                                <button class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                    <i class="material-icons" >clear</i>
                                </button>
                              </td>
                          </tr>

                        </tbody>
                    </table>
                </div>

                <hr>
                  <div class="text-center">
                      <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                              <i class="material-icons">skip_previous</i>
                      </button>

                      <span style="font-size: 85%; color: #a5a5a5"><b>1 - 1</b></span>

                      <button type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                              <i class="material-icons">skip_next</i>
                      </button>
                  </div>
                <hr>

                <!-- ============================================================ MODAL ======================================================================== -->


                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                </div>
                                <div class="modal-body">

                                <div class="row clearfix">
                                  <div class="col-md-2 form-control-label">
                                    <label for="kode">Nama Kabupaten</label>
                                  </div>
                                  <div class="col-md-10">
                                    <div class="form-group">
                                      <div class="form-line">
                                        <input type="text" id="kabupaten" class="form-control" >
                                        <input type="text" id="kabupaten_id" class="form-control" style="display:none" >
                                      </div>
                                    </div>
                                  </div>
                                </div>



                                  <div class="row clearfix">
                                      <div class="col-md-2 form-control-label">
                                          <label for="kode">Nama Kecamatan</label>
                                      </div>
                                      <div class="col-md-10">
                                          <div class="form-group">
                                              <div class="form-line">
                                                  <input v-model="kecamatan" type="text" class="form-control" placeholder="Ex : Baruga">
                                              </div>
                                          </div>
                                      </div>
                                  </div>

                                </div>
                                <div class="modal-footer">
                                    <button @click="addData" type="button" class="btn btn-info waves-effect">SIMPAN</button>
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-green">
                                    <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                </div>
                                <div class="modal-body">

                                  <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                      <label for="kode">Nama Kabupaten</label>
                                    </div>
                                    <div class="col-md-10">
                                      <div class="form-group">
                                        <div class="form-line">
                                          <input v-model="kabupaten" type="text" id="e_kabupaten" class="form-control" >
                                          <input v-model="kabupaten_id" type="text" id="e_kabupaten_id" class="form-control" style="display:none" >
                                        </div>
                                      </div>
                                    </div>
                                  </div>



                                  <div class="row clearfix">
                                      <div class="col-md-2 form-control-label">
                                          <label for="kode">Nama Kecamatan</label>
                                      </div>
                                      <div class="col-md-10">
                                          <div class="form-group">
                                              <div class="form-line">
                                                  <input v-model="kecamatan" type="text" class="form-control" placeholder="Ex : Baruga">
                                              </div>
                                          </div>
                                      </div>
                                  </div>

                                </div>
                                <div class="modal-footer">
                                    <button @click="editData" type="button" class="btn btn-success waves-effect">RUBAH</button>
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                <!-- ============================================================ MODAL ======================================================================== -->




        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>



    </div>
</template>


<script>

const ADD_URL = URL_APP+'api/v1/kecamatan/';


export default {
  name: "monev_kabupaten",
  data() {
    return {

    };
  },

// =============================================================== METHODS =========================================================================
  methods : {


  },
// =============================================================== METHODS =========================================================================

  mounted() {
    localStorage.sidemenu = 'bhumie';
  },
};
</script>
